import { footer } from "../content/site";
import { Container } from "./ui";
import logoFull from "../assets/parkora-logo-full.png";

// lucide-react no longer ships brand/social icons — use simple original
// letter-mark glyphs instead of reproducing third-party logos.
const SOCIAL_INITIALS = {
  Instagram: "IG",
  Facebook: "FB",
  YouTube: "YT",
  LinkedIn: "IN",
};

function scrollTo(e, href) {
  if (!href.startsWith("#")) return;
  e.preventDefault();
  document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
}

export default function Footer() {
  return (
    <footer className="border-t border-navy/8 bg-[var(--color-bg-soft)] pt-16 pb-8">
      <Container>
        <div className="grid gap-12 sm:grid-cols-2 lg:grid-cols-[1.4fr_1fr_auto]">
          <div>
            <img src={logoFull} alt="PARKORA" className="h-11 w-auto" />
            <p className="mt-4 max-w-xs text-sm text-navy/50">{footer.tagline}</p>
            <p className="mt-1 text-sm font-semibold text-navy/40">{footer.parentCompany}</p>
            <address id="contact" className="mt-6 max-w-xs scroll-mt-28 text-sm not-italic text-navy/60">
              <p className="text-xs font-extrabold tracking-wide text-navy/40 uppercase">Contact</p>
              <p className="mt-3 font-semibold text-navy/70">{footer.contact.name}</p>
              <p className="mt-1">{footer.contact.address}</p>
              <p className="mt-2">
                Phone:{" "}
                <a href={footer.contact.phoneHref} className="focus-ring rounded font-semibold hover:text-primary">
                  {footer.contact.phone}
                </a>
              </p>
              <p>
                Email:{" "}
                <a href={`mailto:${footer.contact.email}`} className="focus-ring rounded font-semibold hover:text-primary">
                  {footer.contact.email}
                </a>
              </p>
            </address>
          </div>

          <div>
            <p className="text-xs font-extrabold tracking-wide text-navy/40 uppercase">
              Explore
            </p>
            <ul className="mt-4 flex flex-col gap-3">
              {footer.links.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    onClick={(e) => scrollTo(e, link.href)}
                    className="focus-ring rounded text-sm font-semibold text-navy/60 transition-colors hover:text-primary"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="text-xs font-extrabold tracking-wide text-navy/40 uppercase">
              Follow
            </p>
            <div className="mt-4 flex gap-3">
              {footer.socials.map((social) => (
                <span
                  key={social}
                  aria-label={`${social} (coming soon)`}
                  title={`${social} — coming soon`}
                  className="flex h-10 w-10 items-center justify-center rounded-xl bg-white text-[10px] font-extrabold text-navy/40 ring-1 ring-navy/8"
                >
                  {SOCIAL_INITIALS[social]}
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-14 flex flex-col gap-4 border-t border-navy/8 pt-6 text-xs font-semibold text-navy/40 sm:flex-row sm:items-center sm:justify-between">
          <p>{footer.copyright}</p>
        </div>
      </Container>
    </footer>
  );
}
